import { api } from "@/lib/api";

export function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    if (!src.startsWith("data:")) img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

// Composite a tinted garment + placed design into a square PNG data URL.
export async function compositeMockup({ garmentSrc, colorHex, designSrc, placement, size = 1024, bg = null }) {
  const canvas = document.createElement("canvas");
  canvas.width = size; canvas.height = size;
  const ctx = canvas.getContext("2d");
  if (bg) { ctx.fillStyle = bg; ctx.fillRect(0, 0, size, size); }

  const garment = await loadImage(garmentSrc);
  // fit garment contained
  const gScale = Math.min(size / garment.width, size / garment.height);
  const gw = garment.width * gScale, gh = garment.height * gScale;
  const gx = (size - gw) / 2, gy = (size - gh) / 2;
  ctx.drawImage(garment, gx, gy, gw, gh);

  // tint garment toward colorHex (multiply, masked to garment alpha)
  if (colorHex && colorHex.toLowerCase() !== "#b8bcc4") {
    ctx.globalCompositeOperation = "multiply";
    ctx.fillStyle = colorHex;
    ctx.fillRect(gx, gy, gw, gh);
    ctx.globalCompositeOperation = "destination-in";
    ctx.drawImage(garment, gx, gy, gw, gh);
    ctx.globalCompositeOperation = "source-over";
  }

  if (designSrc) {
    const design = await loadImage(designSrc);
    const dw = size * (placement?.scale ?? 0.28);
    const dh = dw * (design.height / design.width);
    const cx = size * (placement?.x ?? 0.5);
    const cy = size * (placement?.y ?? 0.42);
    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(((placement?.rotation ?? 0) * Math.PI) / 180);
    ctx.drawImage(design, -dw / 2, -dh / 2, dw, dh);
    ctx.restore();
  }
  return canvas.toDataURL("image/png");
}

// Store a share card on the backend (public URL) and try the native share sheet.
export async function publishShareCard(dataUrl, caption = "Wear the Simulation — AETHER") {
  const res = await api.post("/studio/share-card", { image_base64: dataUrl, caption });
  const backend = process.env.REACT_APP_BACKEND_URL;
  const url = `${backend}${res.data.url}`;
  let nativeShared = false;
  try {
    if (navigator.canShare) {
      const blob = await (await fetch(dataUrl)).blob();
      const file = new File([blob], "aether-tryon.png", { type: "image/png" });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ title: "AETHER", text: caption, files: [file] });
        nativeShared = true;
      }
    }
  } catch (e) { /* fall back to links */ }
  return { url, nativeShared };
}

export function socialLinks(shareUrl, caption = "Wear the Simulation — AETHER") {
  const u = encodeURIComponent(shareUrl);
  const t = encodeURIComponent(caption);
  return {
    twitter: `https://twitter.com/intent/tweet?text=${t}&url=${u}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
    whatsapp: `https://wa.me/?text=${t}%20${u}`,
  };
}
